import { AxiosResponse } from 'axios';
import axios from '../api';
import {
    IPaymentReport,
    IPaymentReportChanges,
    IPaymentReportChangesResult,
    IPaymentReportListResponse,
} from '../../helpers/interfaces/payments-reports';

const API_URL = process.env.REACT_APP_API_URL;

class PaymentsReportsService {

    getReports(
        page: number = 1,
        limit: number = 50,
        search: string = '',
        status: string = 'all'
    ): Promise<IPaymentReportListResponse> {
        const params: any = { page, limit };
        if (search.trim()) params.search = search.trim();
        if (status !== 'all') params.status = status;

        return axios.get<IPaymentReportListResponse>(API_URL + 'reports', { params })
            .then((response: AxiosResponse<any>) => {
                const data = response.data.data;
                if (Array.isArray(data)) {
                    return {
                        rows: data,
                        total: data.length,
                        page: 1,
                        limit: data.length || limit,
                        pages: 1,
                    };
                }
                return data;
            })
            .catch((error) => Promise.reject(error));
    }

    getReport(id: number): Promise<IPaymentReport> {
        return axios.get<IPaymentReport>(API_URL + 'report/' + id)
            .then((response: AxiosResponse<any>) => response.data.data)
            .catch((error) => Promise.reject(error));
    }

    createReport(month: number, year: number): Promise<IPaymentReport> {
        return axios.post<any>(API_URL + 'report', { month, year })
            .then((response: AxiosResponse<any>) => response.data.data)
            .catch((error) => Promise.reject(error));
    }

    saveChanges(reportId: number, changes: IPaymentReportChanges): Promise<IPaymentReportChangesResult> {
        return axios.patch<any>(API_URL + 'report/' + reportId + '/changes', changes)
            .then((response: AxiosResponse<any>) => response.data.data)
            .catch((error) => Promise.reject(error));
    }

    validateReport(reportId: number): Promise<IPaymentReport> {
        return axios.put<any>(API_URL + 'report/' + reportId + '/validate')
            .then((response: AxiosResponse<any>) => response.data.data)
            .catch((error) => Promise.reject(error));
    }

    invalidateReport(reportId: number): Promise<IPaymentReport> {
        return axios.put<any>(API_URL + 'report/' + reportId + '/invalidate')
            .then((response: AxiosResponse<any>) => response.data.data)
            .catch((error) => Promise.reject(error));
    }

    deleteReport(reportId: number): Promise<any> {
        return axios.delete<any>(API_URL + 'report/' + reportId)
            .then((response: AxiosResponse<any>) => response.data.data)
            .catch((error) => Promise.reject(error));
    }

    exportReport(reportId: number): Promise<any> {
        return axios.get(API_URL + 'report/' + reportId + '/export', { responseType: 'blob' })
            .then((response: AxiosResponse<any>) => response)
            .catch((error) => Promise.reject(error));
    }
}

export default new PaymentsReportsService();
